import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'store';

const TrialPlanBanner:React.FC<{onAction: (planId: string|number)=>void}> = ({onAction}) => {
    const { membership: membershipData, subscription_plans: plansData } = useSelector((state: RootState) => state.membershipState);
    const activePlan = membershipData?.data?.active_plan ?? null;

    const { plan_days_left: planDaysLeft, plan_days_completed_percentage: planDaysCompletedPercentage, ends_in: endsIn, state: planState, current_plan_day: currentPlanDay, total_plan_days: totalPlanDays } = activePlan?.plan_details ?? {};

    const isTrialPlan = useMemo(() => {
        return !!(activePlan?.plan_frequency?.is_trial);
    }, [activePlan]);


    if (planState === 'expired') return (
        <div className="trial-banner trial-banner--expired">
            <h3 className='trial-banner-icon'>⏰</h3>
            <h3 className='trial-banner-heading m-0'>Your free trial has ended</h3>
            <p className='trial-banner-description text-center'>Your {activePlan?.plan?.name} trial has expired. Subscribe to restore instant full access all your data is safe and ready.</p>
            <div className="features-locked">
                <div className="locked-feature">
                    ⏸️ Campaigns paused
                </div>
                <div className="locked-feature">
                    🔒 Collabs locked
                </div>
                <div className="locked-feature">
                    📊 Analytics frozen
                </div>
            </div>
            <div className="mt-4">
                <button onClick={() => {
                    if(activePlan?.membership_plan_id) onAction(activePlan?.membership_plan_id);
                }} className="trial-plan-action-btn">
                    SUBSCRIBE & KEEP {(activePlan?.plan?.name ?? '').toUpperCase()} PLAN
                </button>
            </div>
        </div>
    );



    return (
        <div className={`trial-banner trial-banner--${planState}`}>
            <div className="radial-blur"></div>
            <div className='corner-circles'>
                <svg width="191" height="153" viewBox="0 0 191 153" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="188.5" cy="-35.5" r="188" stroke="white" strokeOpacity="0.2" strokeLinecap="round" strokeDasharray="4 4" />
                    <circle cx="188.5" cy="-35.5" r="137" stroke="white" strokeOpacity="0.2" strokeLinecap="round" strokeDasharray="4 4" />
                    <circle cx="188.5" cy="-35.5" r="86" stroke="white" strokeOpacity="0.2" strokeLinecap="round" strokeDasharray="4 4" />
                </svg>
            </div>
            <h3 className='trial-banner-heading m-0'>
                {
                    planState === 'safe' && `🎉 Welcome! Your ${activePlan?.plan?.name} trial is live`
                }
                {
                    planState === 'warning' && "⚠️ Only 2 days left on your trial"
                }
                {
                    planState === 'critical' && `🚨 Your trial ${endsIn ? endsIn.toLowerCase() : 'ends in 1 day'}`
                }
            </h3>
            <p className='trial-banner-description'>
                {
                    planState === 'safe' && "Full access is active. Run campaigns, track collabs, analyze competitors everything is unlocked at no cost."
                }
                {
                    planState === 'warning' && "Don't let momentum stop. Your campaigns are live and performing subscribe now to keep everything running without interruption."
                }
                {
                    planState === 'critical' && `This is your final day of free access to ${activePlan?.plan?.name}. After midnight, all campaigns pause, collab data locks, and commission reverts to 20%. Subscribe now to stay live.`
                }
            </p>
            <div className="mt-4">
                <div className="d-flex align-items-center justify-content-between">
                    <span className="current-day">Day <strong>{currentPlanDay}</strong> of <strong>{totalPlanDays}</strong></span>
                    <span className="days-remaining">{planDaysLeft} Day{planDaysLeft !== 1 ? 's' : ''} Remaining</span>
                </div>
                <div className="trial-period-progress mt-1" style={{ background: '#D9D9D9' }}>
                    <div className="trial-period-progress-completed" style={{ width: `${planDaysCompletedPercentage}%`, backgroundColor: (planDaysLeft ?? 0) > 3 ? '#3CC0F8' : (planDaysLeft ?? 0) > 1 ? '#4C2E00' : '#FF2B3A' }}></div>
                </div>
            </div>
            <div className="mt-4">
                <button onClick={() => {
                    if(activePlan?.membership_plan_id) onAction(activePlan?.membership_plan_id);
                }} className="trial-plan-action-btn">
                    SUBSCRIBE & KEEP {(activePlan?.plan?.name ?? '').toUpperCase()} PLAN
                </button>
            </div>
        </div>
    )
}

export default TrialPlanBanner